<template>
  <div id="nike-form">
    <v-container fluid grid-list-md>
      <v-layout row wrap v-if="!show_form">
        <div class="box">
          <h3 :style="cssProps">
            {{ $t("titles.error_inscription." + error_code) }}
          </h3>
          <div class="item">
            <label
              ><span
                v-html="$t('descriptions.error_inscription.' + error_code)"
              ></span>
            </label>
          </div>
        </div>
      </v-layout>
      <v-layout v-else row wrap>
        <div class="box">
          <h3 :style="cssProps">{{ $t("titles.modality") }}</h3>

          <!-- LOCALITAT -->
          <div v-if="!locationSelected" class="item full">
            <!-- <label>{{ $t("titles.nikebcn_submodality") }}</label> -->
            <div>
              <v-radio-group
                v-model="locationSelected"
                row
                @change="changeLocation"
              >
                <v-layout row wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="(location, k) in locations"
                    v-if="location.name != 'campus.nikecampbcn.uixo'"
                    class="week"
                  >
                    <v-radio :label="$t(location.name)" :value="k"> </v-radio>
                    <!-- <label>{{ $t(location.name) }}</label> -->
                    <ul>
                      <li v-for="(campus, i) in location.campus">
                        {{ $t(campus) }}
                      </li>
                      <li>
                        {{ $t("unique_turn") }}
                      </li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-radio-group>
            </div>
          </div>
          <div v-else class="item">
            <label
              >{{ $t("titles.facility_selected") }}
              <span class="selected">{{ $t(location.name) }}</span
              >.
              <span class="change" @click="locationSelected = false">{{
                $t("change")
              }}</span></label
            >
          </div>

          <!-- eSPORT -->
          <div
            v-if="locationSelected"
            class="item full"
            grid-list-md
            text-xs-center
          >
            <v-layout row wrap>
              <v-flex
                xs6
                sm4
                md4
                v-for="(week, j) in location.weeks"
                class="week"
              >
                <div class="selector">
                  <v-checkbox v-model="week.checked" @change="changeWeek(j)">
                    <template v-slot:label>
                      <span>{{
                        $t("unique_turn")
                      }}</span>
                      <span class="date"
                        >({{
                          formatIntervalDates(week.first_date, week.last_date)
                        }})</span
                      >
                    </template>
                  </v-checkbox>
                </div>
                <div class="campus">
                  <v-checkbox
                    v-for="(campus, i) in week.campus"
                    :value="i"
                    v-model="campus.checked"
                    @change="changeCampus(j, i)"
                  >
                    <template v-slot:label>
                      <span v-html="$t(campus.name)"></span>
                    </template>
                  </v-checkbox>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <!-- ESPORT -->
          <!-- <div class="item">
                        <label>{{$t('params.sport')}} <span class="obligatory">*</span> <span v-if="error.duplicated_weeks" class="obligatory"> {{$t('errors.duplicated_weeks')}}</span> </label>

                        <div v-for="(campus, key) in campus_types" v-bind:key="campus.id">

                            <div v-if="key == 'campus.football'">

                                <span>{{$t('descriptions.nike_football')}}</span>

                                <v-checkbox color="green" class="text" v-model="person.weeks" v-bind:value="campus.weeks[Object.keys(campus.weeks)[0]].id" @change="calculatePrice">
                                    <template v-slot:label>
                                        <span v-bind:class="error.person.weeks ? 'obligatory' : ''">{{$t(key)}} ({{$t('params.torn1')}}) : {{campus.weeks[Object.keys(campus.weeks)[0]].name}}</span>
                                    </template>
                                </v-checkbox>

                                <v-checkbox color="green" class="text" v-model="person.weeks" v-bind:value="campus.weeks[Object.keys(campus.weeks)[1]].id" @change="calculatePrice">
                                    <template v-slot:label>
                                        <span v-bind:class="error.person.weeks ? 'obligatory' : ''">{{$t(key)}} ({{$t('params.torn2')}}) : {{campus.weeks[Object.keys(campus.weeks)[1]].name}}</span>
                                    </template>
                                </v-checkbox>

                            </div>

                            <div v-else>

                                <v-checkbox color="green" class="text" v-model="person.weeks" v-bind:value="campus.weeks[Object.keys(campus.weeks)[0]].id" @change="calculatePrice">
                                    <template v-slot:label>
                                        <span v-bind:class="error.person.weeks ? 'obligatory' : ''">{{$t(key)}}: {{campus.weeks[Object.keys(campus.weeks)[0]].name}}</span>
                                    </template>
                                </v-checkbox>

                            </div> -->

          <!--
                            <v-checkbox v-if="Object.keys(campus.weeks).length > 1" color="green" class="text" v-model="campus.checked" v-bind:value="campus.checked" @change="calculatePrice">
                                <template v-slot:label>
                                    <span v-bind:class="error.person.weeks ? 'obligatory' : ''">{{$t(key)}}</span>
                                </template>
                            </v-checkbox>
                            -->

          <!--
                            <v-checkbox v-else color="green" class="text" v-model="person.weeks" v-bind:value="campus.weeks[Object.keys(campus.weeks)[0]].id" @change="calculatePrice">
                                <template v-slot:label>
                                    <span v-bind:class="error.person.weeks ? 'obligatory' : ''">{{$t(key)}}: {{campus.weeks[Object.keys(campus.weeks)[0]].name}}</span>
                                </template>
                            </v-checkbox>
                            -->

          <!--
                            <div class="weeks" v-show="campus.checked" v-if="Object.keys(campus.weeks).length > 1" >
                                <v-autocomplete
                                :class="error.person.weeks ? 'error' : ''"
                                v-model="person.weeks"
                                :items="Object.values(campus.weeks)"
                                item-text="name"
                                item-value="id"
                                flat
                                multiple
                                :browser-autocomplete="'asd2saS<'"
                                ref="weeks"
                                hide-details
                                hide-selected
                                :placeholder="$t('params.campus_weeks')"
                                :auto-selected-first="true"
                                @change="calculatePrice"
                                >
                                <template v-slot:selection="data">
                                    <v-chip
                                    :selected="data.selected"
                                    close
                                    @input="removeWeek(data.item)"
                                    >
                                    {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                    </template>
                                    <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    </v-list-tile-content>
                                    </template>
                                </template>
                                </v-autocomplete>
                            </div>
                            -->

          <!-- </div>

                        <div v-if="football_sport">
                            <label>{{$t('params.field_position')}} <span class="obligatory">*</span> </label>
                            <select v-model="person.goalkeeper" :class="error.goalkeeper ? 'error' : ''" >
                                <option disabled selected value="">{{$t('descriptions.field_position')}}</option>
                                <option value="0">
                                    {{$t('params.field_player')}}
                                </option>
                                <option value="1">
                                    {{$t('params.goalkeeper')}}
                                </option>
                            </select> -->
          <!--
                            <v-radio-group v-model="person.goalkeeper" row>
                                <v-radio value="1">
                                    <template v-slot:label>
                                        <span>{{$t('si')}}</span>
                                    </template>
                                </v-radio>
                                <v-radio value="0">
                                    <template v-slot:label>
                                        <span>{{$t('no')}}</span>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                            -->
          <!-- </div>

                    </div> -->

          <!-- Modalitat -->
          <!-- <div class="item">
                        <label>{{$t('titles.modality')}} {{$t('descriptions.intern_extern')}} <span class="obligatory">*</span> </label>
                        <v-radio-group v-model="person.modality" row @change="modalityChange(); calculatePrice();">
                            <v-radio value="1">
                                <template v-slot:label>
                                    <span :class="error.person.modality ? 'obligatory' : ''">{{$t('intern')}}</span>
                                </template>
                            </v-radio>
                            <v-radio value="2">
                                <template v-slot:label>
                                    <span :class="error.person.modality ? 'obligatory' : ''">{{$t('extern')}}</span>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </div> -->

          <h3 :style="cssProps">{{ $t("titles.player_nike") }}</h3>

          <!-- Nom -->
          <div class="item">
            <label
              >{{ $t("params.name") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              v-bind:class="error.person.name ? 'error' : ''"
              type="text"
              v-model="person.name"
              autocomplete="new-text"
            />
          </div>

          <!-- Cognom -->
          <div class="item">
            <label
              >{{ $t("params.surname") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              v-bind:class="error.person.surname ? 'error' : ''"
              type="text"
              v-model="person.surname"
              autocomplete="new-text"
            />
          </div>

          <!-- DNI -->
          <div class="item">
            <label
              >{{ $t("params.participant_document") }}
              <span class="obligatory">*</span>
              <span class="obligatory error" v-if="error.person.invalit_dni">{{
                " " + $t("errors.invalit_dni")
              }}</span>
              <span class="obligatory error" v-if="error.person.invalit_nie">{{
                " " + $t("errors.invalit_nie")
              }}</span>
              <span class="obligatory error" v-if="error.duplicated_dni">{{
                " " + $t("errors.same_dni")
              }}</span>
            </label>
            <div>
              <v-radio-group v-model="person.document_type" row>
                <v-radio :label="$t('params.dni')" value="1"></v-radio>
                <v-radio :label="$t('params.nie')" value="2"></v-radio>
                <v-radio :label="$t('params.passport')" value="3"></v-radio>
              </v-radio-group>
              <input
                v-if="person.document_type == '1'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="person.document_type == '2'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="person.document_type == '3'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.passport')"
                class="upper shadow"
                autocomplete="new-text"
              />
            </div>
          </div>

          <!-- Birthday -->
          <div class="item" id="birthday">
            <label
              >{{ $t("params.birthday") }} <span class="obligatory">*</span>
              <span>
                {{
                  $t("campus.nikebcn_age", {
                    a: min_age_sport(),
                    b: max_age_sport(),
                  })
                }}</span
              >
              <span> {{ $t("format") }}: (dd/mm/yyyy)</span>
              <span class="obligatory" v-if="error.person.invalit_birthday">
                {{
                  $t("errors.birthday_campus", {
                    a: min_age_sport(),
                    b: max_age_sport(),
                  })
                }}</span
              >
            </label>
            <!-- <input v-bind:class="error.person.birthday ? 'error' : ''" type="date" class="shadow" v-model="person.birthday" autocomplete="new-text"> -->

            <v-menu
              v-model="dialog_birthday"
              autocomplete="new-text"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :class="error.person.birthday ? 'error' : ''"
            >
              <template v-slot:activator="{ on }">
                <!--
                        <v-text-field
                        v-model="person.parsedBirthday"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        class="shadow date-picker"
                        :class="error.person.birthday ? 'error' : ''"
                        ></v-text-field>
                        -->

                <!-- <v-btn @click="dialog_birthday = true">{{$t('params.birthday')}}</v-btn> -->
                <v-text-field
                  prepend-icon="event"
                  v-model="person.parsedBirthday"
                  @click:prepend="dialog_birthday = true"
                  :placeholder="'DD/MM/YYYY'"
                  :class="error.person.birthday ? 'error' : ''"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="person.birthday"
                @input="(dialog_birthday = false), formatBirthday()"
              ></v-date-picker>
            </v-menu>
          </div>

          <!-- Gender -->
          <div class="item">
            <label
              >{{ $t("params.gender") }} <span class="obligatory">*</span>
            </label>
            <v-radio-group v-model="person.gender" row>
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.gender ? 'obligatory' : ''">{{
                    $t("gender.male")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.gender ? 'obligatory' : ''">{{
                    $t("gender.female")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Country -->
          <div class="item" id="country">
            <label>
              {{ $t("params.country") }} <span class="obligatory">*</span>
            </label>
            <v-autocomplete
              :class="error.person.country ? 'error' : ''"
              v-model="person.country_id"
              :items="Object.values(countries)"
              item-text="name"
              item-value="id"
              no-data
              :browser-autocomplete="'asd2saS<'"
              hide-no-data
            >
            </v-autocomplete>
          </div>

          <!-- Address -->
          <div class="item">
            <label
              >{{ $t("params.address") }} <span class="obligatory">*</span>
            </label>
            <input
              v-bind:class="error.person.address ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.address"
              autocomplete="new-text"
            />
          </div>

          <!-- CP -->
          <div class="item">
            <label
              >{{ $t("params.cp") }} <span class="obligatory">*</span>
            </label>
            <input
              v-bind:class="error.person.cp ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.cp"
              autocomplete="new-text"
            />
          </div>

          <!-- City -->
          <div class="item">
            <label
              >{{ $t("params.city") }} <span class="obligatory">*</span>
            </label>
            <input
              :class="error.person.city ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.city"
              autocomplete="new-text"
            />
          </div>

          <!-- State -->
          <div class="item">
            <label
              >{{ $t("params.state") }} <span class="obligatory">*</span>
            </label>
            <input
              :class="error.person.state ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.state"
              autocomplete="new-text"
            />
          </div>

          <!-- Phone -->
          <div class="item">
            <label
              >{{ $t("params.phone") }} <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_phone">
                {{ $t("errors.phone") }}</span
              >
            </label>
            <vue-tel-input
              v-model="person.phone"
              @input="personPhone"
              autocomplete="new-text"
              style="border: none"
              :class="error.person.phone ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Mobile -->
          <div class="item">
            <label
              >{{ $t("params.phone2") }} <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_mobile">
                {{ $t("errors.phone") }}</span
              >
            </label>
            <vue-tel-input
              v-model="person.mobile"
              @input="personMobile"
              autocomplete="new-text"
              style="border: none"
              :class="error.person.mobile ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Emergency Phone -->
          <!--
                    <div class="item">
                        <label>{{$t('params.emergency_phone')}} <span class="obligatory">*</span> <span class="obligatory" v-if="error.person.invalit_phone2"> {{$t('errors.phone')}}</span> </label>
                        <vue-tel-input v-model="person.phone2" @input="personPhone2" autocomplete="new-text" style="border:none" :class="error.person.phone2 ? 'error' : ''" :placeholder="''" defaultCountry="ES" ></vue-tel-input>
                    </div>
                    -->

          <!-- <h3 :style="cssProps">{{$t('titles.know_more')}}</h3> -->

          <!-- Medicamento -->
          <div class="item">
            <label>{{ $t("params.medicamento") }}</label>
            <input
              type="text"
              class="shadow"
              v-model="person.medicamento"
              :placeholder="$t('params.have_medicaments')"
              autocomplete="new-text"
            />
          </div>

          <div class="item"></div>

          <!-- Allergy -->
          <div class="item" id="alergy">
            <label>{{ $t("params.alergy") }}</label>
            <!--
                            <v-autocomplete
                            :class="error.alergy ? 'error' : ''"
                            v-model="person.alergy"
                            :items="Object.values(alergy)"
                            item-text="name"
                            item-value="id"
                            flat
                            multiple
                            :browser-autocomplete="'asd2saS<'"
                            ref="alergy"
                            hide-selected
                            hide-details
                            :placeholder="$t('params.have_allergy')"
                            @change="checkAlergies"
                            >
                            <template v-slot:selection="data">
                                <v-chip
                                :selected="data.selected"
                                close
                                @input="removeAlergy(data.item)"
                                >
                                {{ $t( 'alergy.' + data.item.name) }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>

                                <template v-else>
                                <v-list-tile-content>
                                    <v-list-tile-title> <v-checkbox></v-checkbox>  <span>{{$t('alergy.' + data.item.name)}}</span>  </v-list-tile-title>
                                </v-list-tile-content>
                                </template>

                            </template>
                            </v-autocomplete>
                            -->
            <v-select
              :class="error.alergy ? 'error' : ''"
              v-model="person.alergy"
              :items="Object.values(alergy)"
              item-text="name"
              item-value="id"
              multiple
              :browser-autocomplete="'asd2saS<'"
              ref="alergy"
              @change="checkAlergies"
              id="alergies"
              style="padding: 0"
              attach
              :menuProps="{
                closeOnClick: false,
                closeOnContentClick: true,
                maxHeight: 300,
                openOnClick: false,
              }"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip @input="removeAlergy(item)">
                  {{ $t(item.name) }}
                </v-chip>
              </template>
              <!--
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>

                                <template v-else>
                                <v-list-tile-content>
                                    <v-list-tile-title> <v-checkbox></v-checkbox>  <span>{{$t('alergy.' + data.item.name)}}</span>  </v-list-tile-title>
                                </v-list-tile-content>
                                </template>

                            </template>
                            -->
            </v-select>
          </div>

          <!-- Other allergies -->
          <div class="item">
            <label>{{ $t("params.other_allergies") }}</label>
            <input
              type="text"
              v-model="person.other_allergies"
              autocomplete="new-text"
            />
          </div>

          <!-- Swim -->
          <div class="item">
            <label>{{ $t("swim") }} <span class="obligatory">*</span> </label>
            <v-radio-group v-model="person.swim" row>
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.swim ? 'obligatory' : ''">{{
                    $t("si")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.swim ? 'obligatory' : ''">{{
                    $t("no")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Height -->
          <div class="item">
            <label
              >{{ $t("params.altura") }} <span class="obligatory">*</span>
            </label>
            <input
              v-bind:class="error.person.height ? 'error' : ''"
              type="number"
              class="shadow"
              v-model="person.height"
              autocomplete="new-text"
              pattern="[0-9]"
              @keypress="onlyNumber"
            />
          </div>

          <!-- Bus -->
          <!--
                    <div class="item">
                        <label>{{$t('descriptions.nike_bus')}} <span class="obligatory">*</span> </label>
                        <v-radio-group v-model="person.bus" row>
                            <v-radio value="1">
                                <template v-slot:label>
                                    <span :class="error.person.bus ? 'obligatory' : ''" >{{$t('si')}}</span>
                                </template>
                            </v-radio>
                            <v-radio value="2">
                                <template v-slot:label>
                                    <span :class="error.person.bus ? 'obligatory' : ''" >{{$t('no')}}</span>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </div>
                    -->

          <!-- How meet -->
          <div class="item">
            <label
              >{{ $t("params.how_meet") }} <span class="obligatory">*</span>
            </label>
            <select
              class="shadow"
              v-bind:class="error.person.how_meet ? 'error' : ''"
              v-model="person.how_meet"
            >
              <option
                v-for="type in how_meet"
                v-bind:value="type.id"
                v-bind:key="type.id"
              >
                {{ $t(type.name) }}
              </option>
            </select>
          </div>

          <!-- Language -->
          <div class="item">
            <label
              >{{ $t("campus.communication") }}
              <span class="obligatory">*</span>
            </label>
            <v-radio-group
              v-model="person.language"
              row
              autocomplete="new-text"
            >
              <v-radio
                v-for="language in languages"
                v-bind:value="language.id"
                v-if="language.name != 'en'"
                v-bind:key="language.id"
              >
                <template v-slot:label>
                  <span :class="error.person.language ? 'obligatory' : ''">
                    {{ language.name }}
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Lottery -->
          <div class="item">
            <label>{{ $t("params.lottery") }}</label>
            <v-checkbox v-model="person.lottery">
              <template v-slot:label>
                <span
                  v-html="$t('descriptions.lottery', { s: lottery_link })"
                ></span>
              </template>
            </v-checkbox>
          </div>

          <!-- Observacions -->
          <!--
                    <div class="item">
                        <label>{{$t('params.observacions')}} <span>{{$t('descriptions.observations')}}</span> </label>
                        <textarea type="text" v-model="person.observations" maxlength="255"></textarea>
                    </div>
                    -->

          <h3 :style="cssProps">{{ $t("titles.player_tutor") }}</h3>

          <!-- Name -->
          <div class="item">
            <label
              >{{ $t("params.name") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              v-bind:class="error.legal_guardian.name ? 'error' : ''"
              type="text"
              v-model="legal_guardian.name"
              autocomplete="new-text"
            />
          </div>

          <!-- Surname -->
          <div class="item">
            <label
              >{{ $t("params.surname") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              :class="error.legal_guardian.surname ? 'error' : ''"
              type="text"
              v-model="legal_guardian.surname"
              autocomplete="new-text"
            />
          </div>

          <!-- DNI -->
          <div class="item">
            <label
              >{{ $t("params.parent_document") }}
              <span class="obligatory">*</span>
              <span
                class="obligatory error"
                v-if="error.legal_guardian.invalit_dni"
                >{{ " " + $t("errors.invalit_dni") }}</span
              >
              <span
                class="obligatory error"
                v-if="error.legal_guardian.invalit_nie"
                >{{ " " + $t("errors.invalit_nie") }}</span
              >
              <span class="obligatory error" v-if="error.duplicated_dni">{{
                " " + $t("errors.same_dni")
              }}</span>
            </label>
            <div>
              <v-radio-group v-model="legal_guardian.document_type" row>
                <v-radio :label="$t('params.dni')" value="1"></v-radio>
                <v-radio :label="$t('params.nie')" value="2"></v-radio>
                <v-radio :label="$t('params.passport')" value="3"></v-radio>
              </v-radio-group>
              <input
                v-if="legal_guardian.document_type == '1'"
                v-bind:class="[
                  error.legal_guardian.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="legal_guardian.dni"
                :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="legal_guardian.document_type == '2'"
                v-bind:class="[
                  error.legal_guardian.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="legal_guardian.dni"
                :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="legal_guardian.document_type == '3'"
                v-bind:class="[
                  error.legal_guardian.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="legal_guardian.dni"
                :placeholder="$t('params.passport')"
                class="upper shadow"
                autocomplete="new-text"
              />
            </div>
          </div>

          <div class="item"></div>

          <!-- Emergency Phone -->
          <div class="item">
            <label
              >{{ $t("params.emergency_phone") }}
              <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_phone2">
                {{ $t("errors.phone") }}</span
              >
            </label>
            <vue-tel-input
              v-model="person.phone2"
              @input="personPhone2"
              autocomplete="new-text"
              style="border: none"
              :class="error.person.phone2 ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Email -->
          <div class="item">
            <label
              >{{ $t("params.email") }} <span class="obligatory">*</span>
              <span v-if="error.person.invalit_email" class="obligatory">
                {{ $t("errors.email") }}</span
              >
            </label>
            <input
              v-bind:class="error.person.email ? 'error' : ''"
              type="email"
              class="shadow"
              v-model="person.email"
              autocomplete="new-text"
            />
          </div>

          <h3 :style="cssProps">{{ $t("titles.total_cost") }}</h3>

          <!-- Total Cost -->
          <div class="item">
            <div id="price" v-if="main_price > 0">
              <div class="row">
                <span class="name">{{ $t("titles.total_cost") }}</span>
                <span class="value">{{ main_price }} &euro;</span>
              </div>
              <!-- <h5>{{$t('titles.total_cost')}}:</h5> -->
              <!-- <span v-if="main_price" >{{parseInt(main_price) + parseInt(total)}} &euro;</span> -->
              <div id="discounts-list">
                <div
                  class="row"
                  v-for="discount in person.total_discounts"
                  v-bind:key="discount.id"
                >
                  <span
                    class="name"
                    v-html="$t('descriptions.discount', { a: discount.code })"
                  ></span>
                  <span
                    class="clickable"
                    v-on:click="deleteDiscount(discount)"
                    >{{ $t("params.delete_discount") }}</span
                  >
                  <span class="value">{{ discount.import }} &euro;</span>
                </div>

                <div
                  class="row"
                  v-if="
                    person.brothers_discount &&
                    Object.keys(person.total_discounts).length < 2
                  "
                >
                  <span class="name">{{
                    $t("descriptions.brother_discount")
                  }}</span>
                  <span class="value"
                    >- {{ person.modality == 1 ? 20 : 15 }} &euro;</span
                  >
                </div>

                <!-- <li v-if="person.repeater_discount && Object.keys(person.total_discounts).length < 2" v-html="$t('descriptions.repeater_discount',{a: repeater.value})"></li> -->
              </div>
              <div
                v-if="
                  person.brothers_discount ||
                  Object.keys(person.total_discounts).length > 0
                "
                class="row total"
              >
                <span class="name">{{ $t("params.final_price") }}</span>
                <span class="value">{{ parseInt(total) }} &euro;</span>
              </div>
            </div>
            <div v-else>
              <p>{{ $t("errors.no_campus") }}</p>
            </div>
          </div>

          <!-- Discounts -->
          <div class="item">
            <label>
              <span>{{ $t("campus.max_discounts") }}</span>
              <span v-if="error.invalit_discount_code" class="obligatory">
                {{ $t("errors.invalit_discount_code") }}</span
              >
              <span v-if="error.duplicated_discount_code" class="obligatory">
                {{ $t("errors.duplicated_discount_code") }}</span
              >
              <span v-if="error.limit_discounts_code" class="obligatory">
                {{ $t("errors.nkbcn_limit_discounts_code") }}</span
              >
            </label>
            <v-checkbox
              v-model="person.brothers_discount"
              @change="brotherDiscount"
              v-show="
                (person.weeks.length <= 2 &&
                  Object.keys(person.total_discounts).length == 0) ||
                (person.weeks.length <= 1 &&
                  Object.keys(person.total_discounts).length <= 1)
              "
            >
              <template v-slot:label>
                <span
                  v-html="
                    $t('descriptions.nkbcn_brothers_discount', {
                      a: brother_boarder.value,
                    })
                  "
                ></span>
              </template>
            </v-checkbox>
            <label>
              <span>{{ $t("campus.apply_discounts_codes") }}</span>
            </label>
            <div class="item">
              <input
                class="text"
                :class="
                  error.invalit_discount_code
                    ? 'error'
                    : '' || error.duplicated_discount_code
                    ? 'error'
                    : ''
                "
                v-model="person.discount"
                v-on:keyup.enter="applyDiscount"
              />
            </div>
            <div class="item">
              <button @click="applyDiscount" class="discount">
                {{ $t("params.discount") }}
              </button>
            </div>
          </div>

          <!-- Payment Method -->
          <div class="item">
            <label
              >{{ $t("params.payment_method") }}
              <span class="obligatory">*</span>
            </label>
            <!-- <span>{{$t('campus.payment_description')}}</span> -->
            <v-radio-group v-model="person.payment_type">
              <v-radio value="1">
                <template v-slot:label>
                  <span
                    :class="error.person.payment_type ? 'obligatory' : ''"
                    >{{ $t("campus.100") }}</span
                  >
                  <span v-if="main_price"> ({{ parseInt(total) }} &euro;)</span>
                </template>
              </v-radio>
              <v-radio value="2" v-if="!disable_50">
                <template v-slot:label>
                  <span
                    :class="error.person.payment_type ? 'obligatory' : ''"
                    >{{ $t("campus.50") }}</span
                  >
                  <span v-if="main_price">
                    ({{ parseInt(total) / 2 }} &euro;)</span
                  >
                </template>
              </v-radio>
              <!--
                            <v-radio value="3">
                                <template v-slot:label>
                                    <span :class="error.person.payment_type ? 'obligatory' : ''">{{$t('campus.bank')}}</span>
                                </template>
                            </v-radio>
                            -->
            </v-radio-group>
          </div>

          <div class="item"></div>

          <h3 :style="cssProps">{{ $t("titles.terms_and_conditions") }}</h3>

          <div>
            <!-- Information -->
            <div>
              <v-checkbox v-model="information" class="terms_and_conditions">
                <template v-slot:label>
                  <span>
                    {{ $t("descriptions.information_nikecampbcn") }}
                  </span>
                </template>
              </v-checkbox>
            </div>

            <!-- Termes i condicions -->
            <!--
                        <div>
                            <v-checkbox v-model="terms_and_conditions" class="terms_and_conditions">
                                <template v-slot:label>
                                    <span :class="error.terms_and_conditions ? 'obligatory' : ''" > {{$t('descriptions.terms_and_conditions_1')}} {{$t('descriptions.terms_and_conditions_2')}} </span>
                                </template>
                            </v-checkbox>
                             <button class="information" v-on:click="openDialog()" > {{$t('more_information')}} </button>
                        </div>
                        -->
            <!-- Política de privacitat -->
            <div>
              <v-checkbox v-model="privacy_policy" class="terms_and_conditions">
                <template v-slot:label>
                  <span :class="error.privacy_policy ? 'obligatory' : ''">
                    {{ $t("descriptions.privacy_policy_1") }}
                    <a target="_blank" :href="politicaPrivacidad">{{
                      $t("descriptions.privacy_policy_2")
                    }}</a>
                  </span>
                </template>
              </v-checkbox>
              <!-- <button class="information" v-on:click="openDialog($event)">
                {{ $t("more_information") }}
              </button> -->
            </div>

            <!-- Devolucions -->
            <div>
              <v-checkbox v-model="devolucions" class="terms_and_conditions">
                <template v-slot:label>
                  <span
                    v-bind:class="error.devolucions ? 'obligatory' : ''"
                    v-html="
                      $t('descriptions.devolucions_nkbcn', {
                        s: devolucions_link,
                      })
                    "
                  ></span>
                </template>
              </v-checkbox>
            </div>

            <!-- captcha -->
            <span v-if="error.recaptcha" class="obligatory"
              >* {{ $t("errors.recaptcha") }}</span
            >
            <!-- <div class="g-recaptcha" :data-sitekey="captcha_key"></div> -->
            <vue-recaptcha
              :sitekey="captcha_key"
              @verify="recaptcha = true"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>
          </div>

          <!-- Error Form -->
          <div>
            <span class="obligatory error-form" v-if="error.form">{{
              $t("errors.form")
            }}</span>
          </div>

          <!-- Send -->
          <button
            :style="cssButton"
            type="button"
            id="send"
            v-on:click="validate()"
            :disabled="button_dissabled"
          >
            {{ $t("continue") }}
          </button>

          <!-- Popup -->
          <v-dialog
            id="popup1_dialog"
            v-model="dialog"
            width="600"
            class="modal"
            :hide-overlay="true"
            data-app
          >
            <div id="popup1" class="body">
              <div class="header">
                <img
                  v-on:click="closeDialog()"
                  v-bind:src="'/img/error.svg'"
                  alt="delete"
                />
              </div>
              <div class="main">
                <p class="title">{{ $t("inscription-popup.title1") }}</p>
                <p>{{ "AGRUPACIO ESPORTIVA MICFOOTBALL" }}</p>

                <p class="title">{{ $t("inscription-popup.title2") }}</p>
                <!-- <p>{{$t('inscription-popup.part2', {s: 'ESPORTS AMB XARXA'})}}</p> -->
                <p>{{ $t("nikebcn-popup.part2") }}</p>

                <p class="title">{{ $t("inscription-popup.title3") }}</p>
                <!-- <p>{{$t('inscription-popup.part3')}}</p> -->
                <p>{{ $t("nikebcn-popup.part3") }}</p>

                <p class="title">{{ $t("inscription-popup.title4") }}</p>
                <!-- <p>{{$t('inscription-popup.part4')}}</p> -->
                <p>{{ $t("nikebcn-popup.part4") }}</p>

                <p class="title">{{ $t("inscription-popup.title5") }}</p>
                <p>{{ $t("inscription-popup.part5") }}</p>

                <p class="title">{{ $t("inscription-popup.title6") }}</p>
                <p
                  v-html="
                    $t('inscription-popup.part6', { s: politicaPrivacidad })
                  "
                ></p>
              </div>
            </div>
          </v-dialog>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "InscripcionNikeCamp",

  components: {
    i18n,
    VueRecaptcha,
  },

  data() {
    return {
      show_form: true,
      error_code: false,
      person: {
        // sport: {},
        modality: "2",
        weeks: [],
        name: "",
        surname: "",
        dni: "",
        document_type: "1",
        birthday: "",
        parsedBirthday: "",
        gender: "",
        address: "",
        cp: "",
        city: "",
        state: "",
        phone: "",
        mobile: "",
        phone2: "",
        phone_aux: "",
        mobile_aux: "",
        phone2_aux: "",
        email: "",
        // observations: '',
        medicamento: "",
        alergy: "",
        swim: "",
        height: "",
        // bus: '',
        how_meet: "",
        language: "",
        lottery: false,
        discount: "",
        total_discounts: {},
        payment_type: "1",
        brothers_discount: false,
        services: {},
        repeater_discount: false,
        other_allergies: "",
        goalkeeper: -1,
        diet: "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09",
        country_id: "",
      },
      legal_guardian: {
        name: "",
        surname: "",
        dni: "",
        document_type: "1",
      },
      locationSelected: false,
      error: {
        person: {
          sport: false,
          modality: false,
          weeks: false,
          name: false,
          surname: false,
          dni: false,
          invalit_dni: false,
          invalit_nie: false,
          birthday: false,
          gender: false,
          address: false,
          phone: false,
          mobile: false,
          phone2: false,
          invalit_phone: false,
          invalit_mobile: false,
          invalit_phone2: false,
          email: false,
          invalit_email: false,
          swim: false,
          // bus: false,
          how_meet: false,
          language: false,
          payment_type: false,
          invalit_birthday: false,
          cp: false,
          city: false,
          state: false,
          height: false,
          country: false,
          goalkeeper: false,
        },
        legal_guardian: {
          name: false,
          surname: false,
          dni: false,
          invalit_dni: false,
          invalit_nie: false,
        },
        // terms_and_conditions: false,
        privacy_policy: false,
        devolucions: false,
        recaptcha: false,
        form: false,
        duplicated_weeks: false,
        duplicated_discount_code: false,
        invalit_discount_code: false,
        limit_discounts_code: false,
        duplicated_dni: false,
      },
      alergy: {},
      campus_types: {},
      locations: [],
      how_meet: {},
      languages: {},
      information: false,
      privacy_policy: false,
      dialog: false,
      lang: "",
      devolucions: false,
      devolucions_link: "",
      captcha_key: process.env.VUE_APP_CAPTCHA_KEY,
      lottery_link: "",
      total: 0,
      main_price: 0,
      nike_weeks: {},
      discounts: {},
      brother_boarder: {},
      brother_no_boarder: {},
      services: {},
      repeater: {},
      disable_50: true,
      button_dissabled: false,
      football_sport: false,
      diets: {},
      countries: {},
      dialog_birthday: false,
      min_age: { football: 6, basket: 7 },
      max_age: { football: 16, basket: 16 },
      recaptcha: false,
    };
  },

  created() {
    var self = this;
    this.$overlay.loading();
    // get language
    this.lang = this.$route.params.lang;
    // check if isset
    if (!["ca", "es", "en"].includes(this.lang)) {
      this.lang = "ca";
    }
    moment.locale(this.lang);
    i18n.loadLanguageAsync(this.lang).then(function () {
      // get form information
      self.$store
        .dispatch("getCampusInfo", { event_id: self.$route.params.event_id })
        .then(function (response) {
          if (!response.status) {
            self.show_form = false;
            self.error_code = response.error.code;
          } else {
            self.alergy = JSON.parse(
              JSON.stringify(self.$store.getters["getAlergies"])
            );
            self.alergy["null"] = {
              id: "null",
              name: "no",
            };

            // update languages alergy
            for (let i in self.alergy) {
              self.alergy[i].name = i18n.t("alergy." + self.alergy[i].name);
            }

            self.person.alergy = ["null"];
            self.countries = self.$store.getters["getCountries"];
            self.how_meet = self.$store.getters["getHowMeet"];
            self.languages = self.$store.getters["getLanguages"];
            self.campus_types = JSON.parse(
              JSON.stringify(self.$store.getters["getCampusType"])
            );
            self.locations = {};
            for (var key in self.campus_types) {
              var campus = self.campus_types[key];
              //   console.log('created -> campus', campus)
              var location = key.split(".")[2];
              //   console.log('created -> location', location)
              if (typeof self.locations[location] === "undefined") {
                self.locations[location] = {
                  name:
                    key.split(".")[0] +
                    "." +
                    key.split(".")[1] +
                    "." +
                    key.split(".")[2],
                  checked: false,
                  weeks: {},
                  campus: [],
                };
              }
              for (var k in campus.weeks) {
                var week = campus.weeks[k];
                // console.log('created -> week', week)
                // console.log(typeof self.locations[location].weeks[week['first_date']])
                // if (!(location == 'valles' && (week.first_date == '29/06/2020' || week.first_date == '20/07/2020' || week.first_date == '27/07/2020')) && !(location == 'barcelona' && (week.first_date == '29/06/2020' || week.first_date == '06/07/2020')) && !(location == 'ebre' && (week.first_date == '06/07/2020')) && !(location == 'tarragona' && (week.first_date == '06/07/2020'))) {
                if (
                  typeof self.locations[location].weeks[week["first_date"]] ===
                  "undefined"
                ) {
                  self.locations[location].weeks[week["first_date"]] = {
                    first_date: week["first_date"],
                    last_date: week["last_date"],
                    number:
                      Object.values(campus.weeks).length > 1
                        ? self.numberWeek(week["first_date"])
                        : 1,
                    checked: true,
                    campus_sel: false,
                    campus: [],
                  };
                  //   console.log(self.locations[location].weeks[week['first_date']])
                }
                console.log(location, key, week["first_date"]);
                if (
                  !(
                    location == "barcelona" &&
                    key.match(/futbol/) &&
                    week["first_date"] == "06/07/2020"
                  )
                ) {
                  self.locations[location].weeks[
                    week["first_date"]
                  ].campus.push({
                    id: k,
                    name:
                      key.split(".")[0] +
                      "." +
                      key.split(".")[1] +
                      "." +
                      key.split(".")[3],
                    checked: false,
                  });
                  if (
                    !self.locations[location].campus.includes(
                      key.split(".")[0] +
                        "." +
                        key.split(".")[1] +
                        "." +
                        key.split(".")[3]
                    )
                  )
                    self.locations[location].campus.push(
                      key.split(".")[0] +
                        "." +
                        key.split(".")[1] +
                        "." +
                        key.split(".")[3]
                    );
                }
                // }
              }
            }
            self.nike_weeks = self.$store.getters["getNikeWeeks"];
            self.discounts = self.$store.getters["getDiscounts"];
            self.services = self.$store.getters["getServices"];
            self.diets = self.$store.getters["getDiets"];

            // discounts
            for (let i in self.discounts) {
              // get boarder discount
              if (self.discounts[i].name.match("brothers")) {
                self.brother_boarder = { ...self.discounts[i] };
              }

              // get no boarder discount
              if (self.discounts[i].name.match("brothers_no-boarder")) {
                self.brother_no_boarder = { ...self.discounts[i] };
              }

              // get repeater discount
              if (self.discounts[i].name.match("repeater")) {
                self.repeater = { ...self.discounts[i] };
              }
            }
            // default language comunications
            for (let i in self.languages) {
              if (self.lang == self.languages[i].name) {
                self.person.language = i;
              }
            }
          }
          self.$overlay.hide();
        })
        .catch(() => {
          self.$overlay.hide();
        });
    });

    switch (this.lang) {
      case "ca":
        this.devolucions_link =
          "https://miccamp.com/wp-content/uploads/2025/12/MC25_BCN_TermCond_CAT.pdf?" +
          moment().valueOf();
        this.lottery_link =
          "https://nikecamp.es/wp-content/uploads/2019/12/RIFA-CAT-2020.pdf";
        break;
      case "es":
        this.devolucions_link =
          "https://miccamp.com/wp-content/uploads/2025/12/MC25_BCN_TermCond_ESP.pdf?" +
          moment().valueOf();
        this.lottery_link =
          "https://nikecamp.es/wp-content/uploads/2019/12/RIFA-ESP-2020.pdf";
        break;
      case "en":
        this.devolucions_link =
          "https://nikecamp.es/wp-content/uploads/2019/12/Politica-devoluciones-NC-ENG-1.pdf";
        this.lottery_link =
          "https://nikecamp.es/wp-content/uploads/2019/12/RIFA-ENG-2020.pdf";
        break;
    }

    // dissable
    if (new Date() >= new Date("2026/06/01")) {
      this.disable_50 = true;
    }
  },

  methods: {
    validate() {
      let validate = true;

      // variable for campus_types
      let bCampusTypes = false;

      // loop for each campus types
      for (let i in this.campus_types) {
        // validate if campus type only has one week and is checked
        if (
          Object.keys(this.campus_types[i].weeks).length == 1 &&
          this.person.weeks.includes(Object.keys(this.campus_types[i].weeks)[0])
        ) {
          this.campus_types[i].checked = true;
        }

        // validate if campus is checked and has more than one week
        if (Object.keys(this.campus_types[i].weeks).length > 1) {
          // variable for validate if category is checked and doesn't have any week selected
          let selected = false;

          // loop for each week
          for (let n in this.campus_types[i].weeks) {
            // check if week is selected
            if (this.person.weeks.includes(this.campus_types[i].weeks[n].id)) {
              this.campus_types[i].checked = true;
              selected = true;
            }
          }

          // if category has weeks: selected, else don't selected
          selected
            ? (this.campus_types[i].checked = true)
            : (this.campus_types[i].checked = false);
        }

        // validate if campus is checked
        if (this.campus_types[i].checked) {
          bCampusTypes = true;
        }
      }

      // error campus
      if (!bCampusTypes) {
        this.error.person.sport = true;
        validate = false;
      } else {
        this.error.person.sport = false;
      }

      // person.modality
      if (isEmpty(this.person.modality)) {
        this.error.person.modality = true;
        validate = false;
      } else {
        this.error.person.modality = false;
      }

      // weeks
      if (this.person.weeks.length < 1) {
        this.error.person.weeks = true;
        validate = false;
      } else {
        if (this.validateDuplicatedWeeks()) {
          this.error.person.weeks = false;
          this.error.duplicated_weeks = false;
        } else {
          this.error.person.weeks = true;
          this.error.duplicated_weeks = true;
        }
      }

      // check if sport is football and validate player field type
      if (this.football_sport && isEmpty(this.person.goalkeeper)) {
        this.error.goalkeeper = true;
        validate = false;
      } else {
        this.error.goalkeeper = false;
      }

      // name
      if (isEmpty(this.person.name)) {
        this.error.person.name = true;
        validate = false;
      } else {
        this.error.person.name = false;
      }

      // surname
      if (isEmpty(this.person.surname)) {
        this.error.person.surname = true;
        validate = false;
      } else {
        this.error.person.surname = false;
      }

      // dni nie passport
      if (isEmpty(this.person.dni)) {
        this.error.person.dni = true;
        validate = false;
      } else {
        // dni
        if (this.person.document_type == "1") {
          // remove error nie
          this.error.person.invalit_nie = false;
          // validate dni
          if (!validateDocument(this.person.dni, 1)) {
            this.error.person.invalit_dni = true;
            this.error.person.dni = true;
            validate = false;
            // valit document
          } else {
            this.error.person.invalit_dni = false;
            this.error.person.dni = false;
          }
        }
        // nie
        if (this.person.document_type == "2") {
          // remove error dni
          this.error.person.invalit_dni = false;
          // validate nie
          if (!validateDocument(this.person.dni, 2)) {
            this.error.person.invalit_nie = true;
            this.error.person.dni = true;
            validate = false;
            // valit document
          } else {
            this.error.person.invalit_nie = true;
            this.error.person.dni = false;
          }
        }
      }

      // birthday
      if (
        isEmpty(this.person.birthday) ||
        this.person.parsedBirthday.trim().length != 10
      ) {
        this.error.person.birthday = true;
        validate = false;
      } else {
        if (this.validateYear()) {
          this.error.person.birthday = false;
          this.error.person.invalit_birthday = false;
        } else {
          this.error.person.birthday = true;
          this.error.person.invalit_birthday = true;
          validate = false;
        }
      }

      // gender
      if (isEmpty(this.person.gender)) {
        this.error.person.gender = true;
        validate = false;
      } else {
        this.error.person.gender = false;
      }

      // country
      if (isEmpty(this.person.country_id)) {
        this.error.person.country = true;
        validate = false;
      } else {
        this.error.person.country = false;
      }

      // address
      if (isEmpty(this.person.address)) {
        this.error.person.address = true;
        validate = false;
      } else {
        this.error.person.address = false;
      }

      // cp
      if (isEmpty(this.person.cp)) {
        this.error.person.cp = true;
        validate = false;
      } else {
        this.error.person.cp = false;
      }

      // city
      if (isEmpty(this.person.city)) {
        this.error.person.city = true;
        validate = false;
      } else {
        this.error.person.city = false;
      }

      // state
      if (isEmpty(this.person.state)) {
        this.error.person.state = true;
        validate = false;
      } else {
        this.error.person.state = false;
      }

      // phone
      if (Object.keys(this.person.phone_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.phone_aux.isValid) {
          // ok save phone
          this.person.phone = this.person.phone_aux.number.e164;
          // remove  errors
          this.error.person.phone = false;
          this.error.person.invalit_phone = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_phone = true;
          this.error.person.phone = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.person.phone = true;
        validate = false;
      }

      // mobile
      if (Object.keys(this.person.mobile_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.mobile_aux.isValid) {
          // ok save phone
          this.person.mobile = this.person.mobile_aux.number.e164;
          // remove  errors
          this.error.person.mobile = false;
          this.error.person.invalit_mobile = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_mobile = true;
          this.error.person.mobile = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.person.mobile = true;
        validate = false;
      }

      // emergency phone
      if (Object.keys(this.person.phone2_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.phone2_aux.isValid) {
          // ok save phone
          this.person.phone2 = this.person.phone2_aux.number.e164;
          // remove  errors
          this.error.person.phone2 = false;
          this.error.person.invalit_phone2 = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_phone2 = true;
          this.error.person.phone2 = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.person.phone2 = true;
        validate = false;
      }

      // email
      if (isEmpty(this.person.email)) {
        this.error.person.email = true;
        validate = false;
        // validate email
      } else {
        // valit email
        if (validateEmail(this.person.email)) {
          this.error.person.email = false;
          this.error.person.invalit_email = false;
          // invalit email
        } else {
          validate = false;
          this.error.person.email = true;
          this.error.person.invalit_email = true;
        }
      }

      // observacions
      // if(isEmpty(this.person.observations)) this.person.observations = ''

      // medicamento
      if (isEmpty(this.person.medicamento)) this.person.medicamento = "";

      // swim
      if (isEmpty(this.person.swim)) {
        this.error.person.swim = true;
        validate = false;
      } else {
        this.error.person.swim = false;
      }

      // height
      if (isEmpty(this.person.height)) {
        this.error.person.height = true;
        validate = false;
      } else {
        this.error.person.height = false;
      }

      // bus
      /*
            if(isEmpty(this.person.bus)){
                this.error.person.bus = true;
                validate = false;
            } else {
                this.error.person.bus = false;
            }
            */

      // how meet
      if (isEmpty(this.person.how_meet)) {
        this.error.person.how_meet = true;
        validate = false;
      } else {
        this.error.person.how_meet = false;
      }

      // language
      if (isEmpty(this.person.language)) {
        this.error.person.language = true;
        validate = false;
      } else {
        this.error.person.language = false;
      }

      // Responsable name
      if (isEmpty(this.legal_guardian.name)) {
        this.error.legal_guardian.name = true;
        validate = false;
      } else {
        this.error.legal_guardian.name = false;
      }

      // Responsable surname
      if (isEmpty(this.legal_guardian.surname)) {
        this.error.legal_guardian.surname = true;
        validate = false;
      } else {
        this.error.legal_guardian.surname = false;
      }

      // Responsable dni
      if (isEmpty(this.legal_guardian.dni)) {
        this.error.legal_guardian.dni = true;
        validate = false;
      } else {
        this.error.legal_guardian.invalit_dni = false;
        this.error.legal_guardian.invalit_nie = false;
        // dni
        if (this.legal_guardian.document_type == "1") {
          // remove error nie
          this.error.legal_guardian.invalit_nie = false;
          // validate dni
          if (!validateDocument(this.legal_guardian.dni, 1)) {
            this.error.legal_guardian.invalit_dni = true;
            // valit document
          } else {
            this.error.legal_guardian.invalit_dni = false;
            this.error.legal_guardian.dni = false;
          }
        }
        // nie
        if (this.legal_guardian.document_type == "2") {
          // remove error dni
          this.error.legal_guardian.invalit_dni = false;
          // validate nie
          if (!validateDocument(this.legal_guardian.dni, 2)) {
            this.error.legal_guardian.invalit_nie = true;
            // valit document
          } else {
            this.error.legal_guardian.invalit_nie = true;
            this.error.legal_guardian.dni = false;
          }
        }
      }

      // lottery
      this.person.lottery
        ? (this.person.lottery = 1)
        : (this.person.lottery = 0);

      // brothers discount

      // discounts

      // payment_type
      if (isEmpty(this.person.payment_type)) {
        this.error.person.payment_type = true;
        validate = false;
      } else {
        this.error.person.payment_type = false;
      }

      // termes i condicions
      /*
            if(!this.terms_and_conditions){
                this.error.terms_and_conditions = true;
                validate = false;
            } else {
                this.error.terms_and_conditions = false;
            }
            */

      // política de privacitat
      if (!this.privacy_policy) {
        this.error.privacy_policy = true;
        validate = false;
      } else {
        this.error.privacy_policy = false;
      }

      // política de devolucions
      if (!this.devolucions) {
        this.error.devolucions = true;
        validate = false;
      } else {
        this.error.devolucions = false;
      }

      // google recaptcha
      // try {
      //     // validate recaptcha
      //     if(!grecaptcha.getResponse()){
      //         this.error.recaptcha = true;
      //         validate = false;
      //     } else {
      //         this.error.recaptcha = false;
      //     }
      // } catch(error) {
      //     this.error.recaptcha = false;
      // }

      if (!this.recaptcha) {
        this.error.recaptcha = true;
        validate = false;
      } else {
        this.error.recaptcha = false;
      }

      // validate if dni from participant is different from the legal guardian
      if (
        !isEmpty(this.person.dni) &&
        !isEmpty(this.legal_guardian.dni) &&
        this.person.dni == this.legal_guardian.dni
      ) {
        this.error.duplicated_dni = true;
        // this.error.person.dni = true;
        // this.error.legal_guardian.dni = true;
        validate = false;
      } else {
        this.error.duplicated_dni = false;
        // this.error.person.dni = false;
        // this.error.legal_guardian.dni = false;
      }

      if (validate) {
        this.button_dissabled = true;

        // alergy
        if (this.person.alergy.length == 1 && this.person.alergy[0] == "null")
          this.person.alergy = [];

        // check if selected brother discount, and doesn't have more than 2 discounts
        if (
          this.person.brothers_discount &&
          Object.keys(this.person.total_discounts).length < 2
        ) {
          // check modality
          this.person.modality == 1
            ? // boarder
              (this.person.total_discounts[this.brother_boarder.id] = {})
            : // no boarder
              (this.person.total_discounts[this.brother_no_boarder.id] = {});
        }

        // check if repeater discount, and doesn't have more than 2 discounts
        if (
          this.person.repeater_discount &&
          Object.keys(this.person.total_discounts).length < 2
        ) {
          this.person.total_discounts[this.repeater.id] = {};
        }

        var self = this;
        this.$overlay.loading();
        this.$store
          .dispatch("joinNikeCampusBCN", {
            event_id: self.$route.params.event_id,
            participant_campus: self.person.weeks,
            participant_modality: self.person.modality,
            participant_name: self.person.name,
            participant_surname: self.person.surname,
            participant_dni: self.person.dni,
            participant_document_type: self.person.document_type,
            participant_birthday: self.person.birthday,
            participant_gender: self.person.gender,
            participant_country_id: self.person.country_id,
            participant_address: self.person.address,
            participant_cp: self.person.cp,
            participant_city: self.person.city,
            participant_state: self.person.state,
            participant_phone: self.person.phone,
            participant_mobile: self.person.mobile,
            participant_phone2: self.person.phone2,
            participant_email: self.person.email,
            // participant_observations:       self.person.observations,
            participant_medicament: self.person.medicamento,
            participant_alergy:
              self.person.alergy.length == 1 && self.person.alergy[0] == "null"
                ? []
                : self.person.alergy,
            participant_swim: self.person.swim == "1" ? 1 : 0,
            participant_height: self.person.height,
            // participant_bus:                self.person.bus,
            participant_how_meet: self.person.how_meet,
            participant_language: self.person.language,
            participant_information: self.information ? 1 : 0,
            legal_guardian_name: self.legal_guardian.name,
            legal_guardian_surname: self.legal_guardian.surname,
            legal_guardian_dni: self.legal_guardian.dni,
            legal_guardian_document_type: self.legal_guardian.document_type,
            participant_lottery: self.person.lottery ? 1 : 0,
            participant_payment_type: self.person.payment_type,
            participant_brothers_discount: self.person.brothers_discount
              ? 1
              : 0,
            discounts: Object.keys(self.person.total_discounts),
            services: Object.keys(self.person.services),
            total_price: parseInt(self.total),
            participant_other_allergies: self.person.other_allergies,
            participant_goalkeeper: self.person.goalkeeper,
            participant_diet: self.person.diet,
          })
          .then(function (response) {
            // redirect to mic api
            let oParams = self.$store.getters["getRedsysParams"];
            // window.top.location = process.env.VUE_APP_API_URL + 'form/goToRedsys/' + oParams.budget_id+ '/' + oParams.transaction_id ;
            window.top.location = oParams;
            self.$overlay.hide();
            self.button_dissabled = false;
          })
          .catch(() => {
            self.$overlay.hide();
          });

        self.button_dissabled = false;
      } else {
        this.error.form = true;
      }
    },

    removeAlergy(item) {
      let index = this.person.alergy.indexOf(item.id);
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.person.alergy));
        aux.splice(index, 1);
        this.person.alergy = aux;
      }
      this.checkAlergies();
    },

    removeWeek(item) {
      let index = this.person.weeks.indexOf(item.id);
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.person.weeks));
        aux.splice(index, 1);
        this.person.weeks = aux;
      }
    },

    openDialog(e) {
      this.dialog = true;
      setTimeout(function () {
        // alert( e.pageX + " " + e.pageY + " " + document.getElementById( 'popup1' ).offsetHeight )
        console.log(
          e.pageY,
          document.getElementById("popup1").offsetHeight,
          e.pageY - document.getElementById("popup1").offsetHeight
        );
        document.getElementsByClassName("v-dialog__content")[0].style.top =
          "800px"; // e.pageY - document.getElementById( 'popup1' ).offsetHeight
        document.getElementsByClassName("v-dialog__content")[0].style.position =
          "absolute";
      }, 200);
    },

    closeDialog() {
      this.dialog = false;
    },

    personPhone(input, oResult) {
      this.person.phone_aux = oResult;
    },

    personMobile(input, oResult) {
      this.person.mobile_aux = oResult;
    },

    personPhone2(input, oResult) {
      this.person.phone2_aux = oResult;
    },

    applyDiscount() {
      if (!isEmpty(this.person.discount)) {
        // remove discount errors
        this.error.duplicated_discount_code = false;
        this.error.invalit_discount_code = false;

        // variable with total_discounts
        let total_discounts = Object.keys(this.person.total_discounts).length;

        // if brothers_discount is checked, augment total discounts
        if (this.person.brothers_discount) total_discounts++;

        // if repeter_discount is checked, augment total discounts
        // if (this.person.repeater_discount) total_discounts++

        // validate total discounts (max 2 discounts)
        if (total_discounts <= 1) {
          let campus_type = "";
          for (var k in this.campus_types) {
            this.person.weeks.forEach((week) => {
              if (Object.keys(this.campus_types[k].weeks).includes(week)) {
                campus_type = k;
              }
            });
          }
          // discount
          var self = this;
          this.$store
            .dispatch("checkDiscount", {
              event_id: this.$route.params.event_id,
              code: this.person.discount,
              campus_type: campus_type,
              weeks: this.person.weeks.toString(),
              modality: this.person.modality,
            })
            .then(function () {
              // get result
              let result = self.$store.getters["getPromotionalCode"];
              // valit code
              if (result.status) {
                // valit code
                if (
                  !self.person.total_discounts.hasOwnProperty(
                    result.data.discount_id
                  )
                ) {
                  var discount = self.discounts[result.data.discount_id];
                  var bError = false;
                  var bWeekDiscount = false;
                  var bBeca = false;

                  if (
                    (discount.name == "nikecampbcn.discounts.uixo_location" &&
                      self.location.name != "campus.nikecampbcn.uixo") ||
                    (discount.name == "nikecampbcn.discounts.bcn_location" &&
                      self.location.name != "campus.nikecampbcn.barcelona") ||
                    (discount.name == "nikecampbcn.discounts.valles_location" &&
                      self.location.name != "campus.nikecampbcn.valles") ||
                    (discount.name == "nikecampbcn.discounts.ebre_location" &&
                      self.location.name != "campus.nikecampbcn.ebre") ||
                    (discount.name == "nikecampbcn.discounts.NCnikest2020" &&
                      self.location.name != "campus.nikecampbcn.valles") ||
                    (discount.name == "nikecampbcn.discounts.NCnikebcn2020" &&
                      self.location.name != "campus.nikecampbcn.barcelona")
                  ) {
                    bError = true;
                  }
                  // else if (discount.name == 'nikecampbcn.discounts.uixo_location' || discount.name == 'nikecampbcn.discounts.bcn_location' || discount.name == 'nikecampbcn.discounts.valles_location' || discount.name == 'nikecampbcn.discounts.ebre_location') {
                  else if (
                    discount.name != "nikecampbcn.discounts.becankbcn" &&
                    discount.name != "nikecampbcn.discounts.NCnikebcn2020" &&
                    discount.name != "nikecampbcn.discounts.NCnikest2020" &&
                    discount.name != "nikecampbcn.discounts.repeaters" &&
                    discount.name != "nikecampbcn.discounts.sarria_location" &&
                    discount.name != "nikecampbcn.discounts.damian_location"
                  ) {
                    bWeekDiscount = true;
                  } else if (
                    discount.name == "nikecampbcn.discounts.becankbcn"
                  ) {
                    bBeca = true;
                  }

                  if (!bError) {
                    // save discount
                    self.person.total_discounts[result.data.discount_id] =
                      result.data;
                    self.person.total_discounts[result.data.discount_id].name =
                      discount.name;
                    self.calculatePrice();
                    // remove discount from input
                    self.person.discount = "";

                    if (bWeekDiscount) {
                      self.total =
                        parseInt(self.main_price) +
                        parseInt(result.data.import) * self.person.weeks.length;
                      self.person.total_discounts[
                        result.data.discount_id
                      ].unit_price = parseInt(result.data.import);
                      self.person.total_discounts[
                        result.data.discount_id
                      ].import =
                        parseInt(result.data.import) * self.person.weeks.length;
                      console.log("applyDiscount -> self.total", self.total);
                      console.log(
                        "applyDiscount -> self.main_price",
                        self.main_price
                      );
                      console.log(
                        "applyDiscount -> self.person.weeks.length",
                        self.person.weeks.length
                      );
                    } else if (bBeca) {
                      self.total =
                        parseInt(self.main_price) +
                        parseInt(result.data.import);
                      self.total = self.total > 0 ? self.total : 0;
                      self.person.total_discounts[
                        result.data.discount_id
                      ].import = self.main_price;
                    } else {
                      self.person.total_discounts[
                        result.data.discount_id
                      ].import = parseInt(result.data.import);
                      var discounts = 0;
                      for (var k in self.person.total_discounts) {
                        discounts += self.person.total_discounts[k].import;
                      }
                      console.log("APPLY DISCOUNT", self.main_price, discounts);
                      self.total = parseInt(self.main_price) + discounts;
                    }

                    if (self.person.brothers_discount) {
                      self.total -= 15;
                    }

                    self.error.limit_discounts_code = false;
                    self.error.duplicated_discount_code = false;
                    self.error.invalit_discount_code = false;
                  } else {
                    self.error.invalit_discount_code = true;
                  }
                  // duplicated code
                } else {
                  self.error.duplicated_discount_code = true;
                }
                // invalit code
              } else {
                self.error.invalit_discount_code = true;
              }
            });
          // valit code, show worning
        } else {
          this.error.limit_discounts_code = true;
        }
      }
    },

    calculateDiscount() {
      let total_discounts = Object.keys(this.person.total_discounts).length;
      if (total_discounts == 1) {
        var discount =
          this.person.total_discounts[
            Object.keys(this.person.total_discounts)[0]
          ];
        console.log("calculateDiscount -> discount", discount);
        var bError = false;
        var bWeekDiscount = false;
        var bBeca = false;

        if (
          (discount.name == "nikecampbcn.discounts.uixo_location" &&
            this.location.name != "campus.nikecampbcn.uixo") ||
          (discount.name == "nikecampbcn.discounts.bcn_location" &&
            this.location.name != "campus.nikecampbcn.barcelona") ||
          (discount.name == "nikecampbcn.discounts.valles_location" &&
            this.location.name != "campus.nikecampbcn.valles") ||
          (discount.name == "nikecampbcn.discounts.ebre_location" &&
            this.location.name != "campus.nikecampbcn.ebre") ||
          (discount.name == "nikecampbcn.discounts.NCnikest2020" &&
            this.location.name != "campus.nikecampbcn.valles") ||
          (discount.name == "nikecampbcn.discounts.NCnikebcn2020" &&
            this.location.name != "campus.nikecampbcn.barcelona")
        ) {
          //   bError = true
        }
        // else if (discount.name == 'nikecampbcn.discounts.uixo_location' || discount.name == 'nikecampbcn.discounts.bcn_location' || discount.name == 'nikecampbcn.discounts.valles_location' || discount.name == 'nikecampbcn.discounts.ebre_location') {
        else if (
          discount.name != "nikecampbcn.discounts.becankbcn" &&
          discount.name != "nikecampbcn.discounts.NCnikebcn2020" &&
          discount.name != "nikecampbcn.discounts.NCnikest2020"
        ) {
          bWeekDiscount = true;
        } else if (discount.name == "nikecampbcn.discounts.becankbcn") {
          bBeca = true;
        }

        if (!bError) {
          if (bWeekDiscount) {
            this.total =
              parseInt(this.main_price) +
              parseInt(discount.unit_price) * this.person.weeks.length;
            this.person.total_discounts[discount.discount_id].import =
              parseInt(discount.unit_price) * this.person.weeks.length;
            console.log("applyDiscount -> this.total", this.total);
            console.log("applyDiscount -> this.main_price", this.main_price);
            console.log(
              "applyDiscount -> this.person.weeks.length",
              this.person.weeks.length
            );
          } else if (bBeca) {
            this.total = parseInt(this.main_price) + parseInt(discount.import);
            this.total = this.total > 0 ? this.total : 0;
            this.person.total_discounts[discount.discount_id].import =
              this.main_price;
          } else {
            this.total = parseInt(this.main_price) + parseInt(discount.import);
            this.person.total_discounts[discount.discount_id].import = parseInt(
              discount.import
            );
          }
        }
      }
    },

    validateDuplicatedWeeks() {
      // first loop for weeks
      for (let i in this.person.weeks) {
        // get week one
        let week = this.nike_weeks[this.person.weeks[i]];
        // second loop for weeks
        for (let n in this.person.weeks) {
          // get second week
          let week2 = this.nike_weeks[this.person.weeks[n]];
          // validate if selected two weeks with the same first date
          if (week.first_date == week2.first_date && week.id != week2.id) {
            // incorrect
            return false;
          }
        }
      }
      // ok
      return true;
    },

    brotherDiscount() {
      // validate discounts length
      if (Object.keys(this.person.total_discounts).length <= 1) {
        // add brothers_discount
        this.person.brothers_discount
          ? // add brother discount
            (this.total =
              parseInt(this.total) + this.brother_boarder.value * -1)
          : // removed brother discount
            (this.total = parseInt(this.total) + this.brother_boarder.value);
      }
    },

    modalityChange() {
      // check if selected borther_discount
      if (this.person.brothers_discount) {
        if (this.person.modality == 1) {
          this.total =
            parseInt(this.total) -
            this.brother_no_boarder.value +
            this.brother_boarder.value;
        } else {
          this.total =
            parseInt(this.total) -
            this.brother_boarder.value +
            this.brother_no_boarder.value;
        }
      }
    },

    deleteDiscount(discount) {
      // copy object
      var person = { ...this.person };
      var result = { ...person.total_discounts };
      // remove discount
      delete result[discount.discount_id];
      // restore price
      this.total = parseInt(this.total) + parseInt(discount.import) * -1;
      // save result to total discounts
      person.total_discounts = result;
      this.person = person;
      // remove limit discounts error
      this.error.limit_discounts_code = false;

      this.calculatePrice();
    },

    calculatePrice() {
      var total = this.total - this.main_price;
      this.main_price = 0;
      this.person.services = {};

      for (let i in this.services) {
        var service = this.services[i];
        if (service.name == "nikecampbcn.services.inscription") {
          this.person.services[service.id] = service.id;
          var weeks = ["one", "two", "three", "four", "five"];
          var num_week = 0;

          var canApplyWeekDiscount =
            Object.keys(this.person.total_discounts).length <= 1;
          if (this.person.weeks.length > 1)
            this.person.brothers_discount = false;
          //   console.log('calculatePrice -> canApplyWeekDiscount', canApplyWeekDiscount)
          this.person.weeks.forEach((week) => {
            this.main_price += service.import;
            if (canApplyWeekDiscount) {
              for (var k in this.discounts) {
                var disc = this.discounts[k];
                console.log(
                  "calculatePrice -> disc",
                  disc.name,
                  weeks[num_week]
                );
                if (
                  disc.name ==
                  "nikecampbcn.discounts." + weeks[num_week] + "_week"
                ) {
                  console.log("FOUND DISCOUNT WEEK");
                  this.main_price -= disc.value;
                }
              }
            }
            num_week++;
          });
        }
      }
      this.total = this.main_price + total;
    },

    checkAlergies() {
      if (this.person.alergy.length > 0) {
        var pos = this.person.alergy.indexOf("null");
        if (pos >= 0) this.person.alergy.splice(pos, 1);
      } else {
        this.person.alergy.push("null");
      }
    },

    onlyNumber(evt) {
      if (!Number.isInteger(parseInt(evt.key))) {
        evt.preventDefault();
      }
    },

    formatBirthday() {
      this.person.parsedBirthday = moment(this.person.birthday).format(
        "DD/MM/YYYY"
      );
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    validateYear() {
      let validate = true;

      // get participant birthday
      let person_birthday = moment(this.person.birthday).format("DD/MM/YYYY");

      // loop for each campus week
      for (let i in this.person.weeks) {
        // get campus dates

        let campus_first_date =
          this.nike_weeks[this.person.weeks[i]].first_date;
        let campus_last_date = this.nike_weeks[this.person.weeks[i]].last_date;

        // validate year
        if (
          moment(campus_first_date, "DD/MM/YYYY").year() -
            moment(person_birthday, "DD/MM/YYYY").year() >=
            this.min_age_sport() &&
          moment(campus_last_date, "DD/MM/YYYY").year() -
            moment(person_birthday, "DD/MM/YYYY").year() <=
            this.max_age_sport() + 1
        ) {
          // validate min_age
          if (
            moment(campus_first_date, "DD/MM/YYYY").year() -
              moment(person_birthday, "DD/MM/YYYY").year() ==
            this.min_age_sport()
          ) {
            // validate smaller month
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) <
              0
            ) {
              validate = false;
            }

            // validate same month
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) ==
              0
            ) {
              console.log(
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date()
              );

              // day bigger than campus, invalid
              if (
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date() <
                0
              ) {
                validate = false;
              }
            }
          }

          // validate max_age
          if (
            moment(campus_last_date, "DD/MM/YYYY").year() -
              moment(person_birthday, "DD/MM/YYYY").year() ==
            this.max_age_sport() + 1
          ) {
            // validate first day from campus (MONTH)
            if (
              moment(campus_first_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) >
              0
            ) {
              validate = false;
            }

            // validate first day from campus (DAY)
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) ==
              0
            ) {
              // validate peron day with the last day of the campus
              if (
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date() >=
                0
              ) {
                validate = false;
              }
            }
          }
        } else {
          validate = false;
        }
      }

      return validate;
    },

    min_age_sport() {
      var sport = "football";
      console.log(this.person.services);
      if (Object.keys(this.person.services).length > 0) {
        console.log(this.campus_types);
        for (var k in this.campus_types) {
          for (var j in this.campus_types[k].weeks) {
            console.log(k, j, this.person.weeks[0]);
            if (j == this.person.weeks[0]) {
              sport =
                k.match("football") || k.match("futbol")
                  ? "football"
                  : "basket";
            }
          }
        }
      }
      // Object.keys(this.person.services) > 0
      //   ? this.this.services[Object.keys(this.person.services)[0]].name.match(
      //       "football"
      //     )
      //     ? "football"
      //     : "basket"
      //   : "football";
      console.log("min_age_sport", sport, this.min_age[sport]);
      return this.min_age[sport];
    },

    max_age_sport() {
      var sport = "football";
      if (Object.keys(this.person.services).length > 0) {
        for (var k in this.campus_types) {
          for (var j in this.campus_types[k].weeks) {
            if (j == this.person.weeks[0]) {
              console.log(k);
              sport =
                k.match("football") || k.match("futbol")
                  ? "football"
                  : "basket";
            }
          }
        }
      }
      console.log("max_age_sport", sport, this.max_age[sport]);
      return this.max_age[sport];
    },

    changeLocation() {
      this.person.total_discounts = {};
      this.person.weeks = [];
      this.main_price = 0;
      this.total = 0;

      var self = this;
      setTimeout(function () {
        var location = { ...self.locations[self.locationSelected] };
        //   console.log('changeLocation -> location', location)
        self.location = location;
      }, 200);
    },

    changeWeek(w) {
      var location = { ...this.locations[this.locationSelected] };
      var week = location.weeks[w];

      if (week.checked) {
        week.campus_sel = 0;
        week.campus[0].checked = true;
      } else {
        week.campus_sel = false;
        week.campus.forEach((campus) => {
          campus.checked = false;
        });
      }

      this.location = location;
    },

    changeCampus(w, c) {
      var location = { ...this.locations[this.locationSelected] };
      var week = location.weeks[w];

      week.campus_sel = week.campus[c].checked ? c : false;
      week.checked = week.campus[c].checked;

      if (week.campus[c].checked) {
        week.campus.forEach((campus) => {
          if (campus.name != week.campus[c].name) campus.checked = false;
        });
      }

      this.location = location;
    },

    formatIntervalDates(d1, d2) {
      //   console.log('formatIntervalDates -> d1, d2', d1, d2)
      return (
        i18n.t("from") +
        " " +
        moment(d1, "DD/MM/YYYY").format("DD") +
        " " +
        i18n.t("of") +
        " " +
        moment(d1, "DD/MM/YYYY").format("MMMM") +
        " " +
        i18n.t("to") +
        " " +
        moment(d2, "DD/MM/YYYY").format("DD") +
        " " +
        i18n.t("of") +
        " " +
        moment(d2, "DD/MM/YYYY").format("MMMM")
      );
    },

    weeks(location) {
      console.log(location);
      var weeks = "";
      var n = 1;
      for (var k in location.weeks) {
        if (weeks != "") weeks += ",";
        weeks += " " + location.weeks[k].number;
      }

      return weeks;
    },

    numberWeek(start_date) {
      console.log("numberWeek -> start_date", start_date);
      switch (start_date) {
        case "27/06/2022":
          return 1;
        case "04/07/2022":
          return 2;
        case "13/07/2021":
          return 3;
        case "20/07/2021":
          return 4;
        case "27/07/2021":
          return 5;
      }
    },
  },

  computed: {
    cssProps() {
      return {
        "background-color": this.$store.getters["getEventColor"],
      };
    },
    cssButton() {
      return {
        background: this.$store.getters["getEventColor"],
      };
    },

    location: {
      get: function () {
        // console.log('GET location -> location')
        var location = this.locations[this.locationSelected];
        var weeks = [];
        for (var key in location.weeks) {
          weeks.push(key);
        }
        weeks.sort(function (a, b) {
          if (moment(a).valueOf() < moment(b).valueOf()) return -1;
          return 1;
        });

        var auxWeeks = [];
        weeks.forEach((week) => {
          auxWeeks.push(location.weeks[week]);
        });
        location.weeks = auxWeeks;
        return location;
      },
      set: function (newLocation) {
        console.log("SET location -> location", newLocation);
        this.location[this.locationSelected] = newLocation;
        var locationSelected = this.locationSelected;
        this.locationSelected = false;
        this.locationSelected = locationSelected;

        var self = this;
        self.person.weeks = [];
        newLocation.weeks.forEach((week) => {
          if (week.checked) {
            week.campus.forEach((campus) => {
              if (campus.checked) {
                self.person.weeks.push(campus.id);
              }
            });
          }
        });

        this.calculatePrice();
        this.calculateDiscount();
      },
    },

    politicaPrivacidad() {
      switch (this.lang) {
        case "ca":
          return (
            "https://miccamp.com/wp-content/uploads/2025/02/MC25_PoliticaPrivacitat_CAT.pdf?" +
            moment().valueOf()
          );
        case "es":
          return (
            "https://miccamp.com/wp-content/uploads/2025/02/MC25_PoliticaPrivacidad_ESP.pdf?" +
            moment().valueOf()
          );
      }
      return false;
    },
  },

  watch: {
    football_sport: function () {
      this.football_sport
        ? (this.person.goalkeeper = "")
        : (this.person.goalkeeper = "");
    },

    "person.parsedBirthday": function () {
      if (moment(this.person.parsedBirthday, "DD/MM/YYYY").isValid()) {
        this.person.birthday = moment(
          this.person.parsedBirthday,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
      }
    },
  },
};
</script>
<style lang="scss">
// iframe
body {
  //overflow: hidden
}

body::-webkit-scrollbar {
  width: 0;
}

#nike-form {
  background-color: #fff;
  margin: 0;
  padding: 5px;
  height: 100%;

  .error-form {
    margin: 0 auto;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }

  .obligatory {
    color: $alert-color !important;
    font-weight: bold !important;
  }

  .clickable {
    margin-left: 10px;
    color: $alert-color !important;
    font-weight: bold !important;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  hr {
    background-color: #ccc;
    margin: 30px auto;
    width: 95%;
    background-color: transparent;
  }

  h2,
  h3,
  h4,
  h6 {
    // font-family: AvantGarde-Bold;
    color: $main-color !important;
    text-transform: uppercase;
  }

  h3 {
    font-size: 24px;
    background: #172654;
    color: #fff !important;
    padding: 4px;
  }

  h5 {
    font-weight: normal;
    // font-family: Roboto;
  }

  h6 {
    font-size: 18px;
    background: #eee;
    color: #999 !important;
    padding: 8px;
  }

  .alert {
    background-color: #e5faff;
    padding: 15px;
    width: 98%;
    margin: 20px auto;
    font-size: 16px;
  }

  .container.fluid.grid-list-md {
    padding: 0;
  }

  h2 {
    text-align: center;
    text-transform: uppercase;
    font-style: italic;
    // font-family: AvantGarde-Bold;
  }

  .v-menu__content {
    margin-top: 43px;

    * {
      text-decoration: none !important;
    }
  }

  a {
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
    // font-family: AvantGarde-Bold;
  }

  .box {
    width: 100%;
    margin: 0 auto;
    height: auto;
    overflow: auto;
    text-align: left;
    // font-family: AvantGarde-Bold;

    .message.error {
      color: $warning-color;
      // font-family: AvantGarde-Bold;
    }

    label {
      font-family: AvantGarde-Bold;
      font-size: 14px;
      margin-bottom: 3px;
      // padding: 0;
      // margin-bottom: 5px;
      display: block;
      color: black;
      font-weight: bold;

      .selected {
        font-size: 18px !important;
      }

      .change {
        font-size: 14px !important;
        text-decoration: underline;
        cursor: pointer;
        margin-left: 10px;
        font-weight: bold;
      }
    }

    #country {
      .v-input {
        border: none;
      }
    }

    .item {
      width: calc(50% - 40px);
      margin: 10px 20px;
      display: inline-block;
      vertical-align: top;

      &.full {
        width: calc(100% - 80px);
      }

      input,
      select,
      .v-autocomplete .v-input__slot,
      textarea,
      .v-select {
        width: 100%;
        padding: 5px 6px;
        margin-bottom: 0;
        border: 1px solid $main-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;
        // font-family: Roboto-Light;
        // font-weight: lighter;

        &::placeholder {
          color: $dark-color;
          // font-family: Roboto-Light;
          // font-weight: lighter;
          opacity: 0.5;
        }

        &.shadow:focus {
          border-color: #66afe9;
          outline: 0;
          border-left: 6px solid #66afe9;
        }
      }

      .discount {
        padding: 5px 6px;
        margin-bottom: 0;
        border: 1px solid $main-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;
        background: #000 !important;
        color: $secondary-color;
        &:hover {
          background: rgb(255, 70, 0);
        }
      }

      .v-autocomplete,
      .v-select {
        margin-top: 0;
        padding-top: 0;
        font-family: AvantGarde-Bold;
        .v-input__control {
          font-family: AvantGarde-Bold;
          .v-input__slot {
            margin: 0;
            padding: 0;

            &:after,
            &:before {
              content: "";
              border: none !important;
              font-family: AvantGarde-Bold;
            }
          }
          .v-select__slot {
            border: none;
            font-family: AvantGarde-Bold;
            // padding: 5px 12px;
            padding: 0;
            input {
              border: none;
              margin: 0;
            }
          }
        }
      }

      .error {
        border-color: red !important;

        &::placeholder {
          color: $alert-color !important;
          opacity: 1;
        }

        .v-input__slot {
          border-color: $alert-color;
        }

        .vti__input {
          border-color: red !important;
        }
      }

      .date-picker.error {
        input {
          border: 1px solid red;
        }
      }

      .upper {
        text-transform: uppercase;
      }

      span {
        color: black;
        font-size: 16px;
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      select {
        background-image: url("/img/sort-down.svg");
        background-size: 10px;
        background-position: right 10px center;
        background-repeat: no-repeat;
        // font-family: AvantGarde-Bold;
      }

      select option {
        font-size: 14pt;
      }

      .v-input__slot {
        margin: 0;
      }

      .week {
        .selector {
          span {
            font-family: AvantGarde-Bold;
            font-size: 14px;
            margin-bottom: 3px;
            display: block;
            color: black;
            font-weight: bold;

            &.date {
              font-weight: initial !important;
              color: initial !important;
              font-size: 12px;
              font-family: Roboto-Light;
            }
          }
        }
        .campus {
          padding-left: 30px;

          .v-input--selection-controls {
            margin-top: 0;
          }
        }

        ul {
          list-style: square inside;
        }
      }
    }

    #alergy {
      .v-text-field__details {
        display: none !important;
      }
    }

    #birthday {
      .error {
        input {
          border: 1px solid red;
        }
      }
      /*
                input {
                    border: 1px solid red;
                }
                */
    }

    #price {
      background-color: #ddd;
      padding: 20px;

      .row {
        width: 100%;
        margin: 5px 0;
        overflow: hidden;

        .name {
          font-size: 16px;
          b {
            text-transform: uppercase;
            font-weight: bold;
            font-family: Roboto-Bold;
          }
        }
        .clickable {
          font-size: 14px;
          margin-left: 10px;
        }
        .value {
          font-weight: bold;
          font-size: 20px;
          float: right;
        }

        &.total {
          border-top: 1px solid rgba(0, 0, 0, 0.5);
          padding-top: 10px;
          margin-top: 10px;
          font-family: Roboto-Bold;

          .name,
          .value {
            font-family: Roboto-Bold;
            // text-transform: uppercase;
            font-size: 24px;
          }
        }
      }
      h5,
      span {
        display: inline-block;
        height: 100%;
        margin: 0;
        padding: 0;
        vertical-align: middle;
      }

      h5 {
        margin-right: 20px;
      }

      span {
        font-weight: bold;
        // color: $main-color;
        font-size: 40px;
      }
    }

    #discounts-list {
      ul {
        li {
          list-style-type: circle;
        }
      }
    }

    .terms_and_conditions {
      margin: 0;
      display: inline-block;
    }

    .information {
      border: 1px solid $secondary-color;
      margin-left: 10px;
      padding: 10px;
    }

    #send {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: AvantGarde-Bold;
      margin-top: 5px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #000022;
      color: $secondary-color;

      &:hover {
        background-color: rgb(255, 70, 0) !important;
      }
    }
  }
}

@media (max-width: 720px) {
  #nike-form {
    .box {
      .item {
        width: calc(100% - 20px);
      }
    }
  }
}

@include media(">phone", "<tablet") {
  #nike-form {
    .box {
      .item {
        margin: 0 !important;
      }
    }
  }
}
</style>
